// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// countdown.ts — 3, 2, 1, fire (principle #15).
//
// A round never begins the instant the board appears. Whoever happened to be looking gets a free
// head start otherwise, and the table reads as a jump cut. Each peer counts locally from the start
// message, so everyone is in step to within one network hop — and the AUDIO carries it, because
// players are looking at the racks and not at the overlay.
//
// It runs on setInterval, never rAF: a peer whose tab is in the background would otherwise never
// count down at all.

interface Sfx {
  play(name: string, opts?: { pitch?: number; gain?: number }): void;
}

export const COUNT_FROM = 3;
export const TICK_MS = 700;

export function runCountdown(host: HTMLElement, sfx: Sfx, onDone: () => void): () => void {
  const el = document.createElement('div');
  el.className = 'countdown';
  el.setAttribute('aria-live', 'assertive');
  host.appendChild(el);

  let n = COUNT_FROM;
  const show = (text: string, cls = ''): void => {
    el.innerHTML = `<span class="cd-n ${cls}">${text}</span>`;
  };
  show(String(n));
  sfx.play('blip', { pitch: 1 });

  const timer = setInterval(() => {
    n--;
    if (n > 0) {
      show(String(n));
      sfx.play('blip', { pitch: 1 + (COUNT_FROM - n) * 0.15 });
      return;
    }
    if (n === 0) {
      show('Fire', 'go');
      sfx.play('round', { pitch: 1.2 });
      return;
    }
    stop();
    onDone();
  }, TICK_MS);

  function stop(): void {
    clearInterval(timer);
    el.remove();
  }
  return stop;
}
